// Single source of truth for booking status labels/colours.
// Status codes come from the backend; 9 (Received At Port) was added later,
// so it sits between 4 (Shipped) and 5 (Received At Warehouse) in flow order.

export const BOOKING_STATUS = {
  0: { label: "Booked", color: "#64748b" },
  1: { label: "Assigned", color: "#d97706" },
  2: { label: "Picked Up", color: "#ea580c" },
  3: { label: "In UK Warehouse", color: "#92400e" },
  4: { label: "Shipped", color: "#2563eb" },
  9: { label: "Received At Port", color: "#0891b2" },
  5: { label: "Received At Warehouse", color: "#4f46e5" },
  6: { label: "Out For Delivery", color: "#0d9488" },
  8: { label: "Partially Delivered", color: "#ca8a04" },
  7: { label: "Delivered", color: "#16a34a" },
  "-1": { label: "Cancelled", color: "#dc2626" },
};

// Pickup area first, then delivery area, Cancelled always last
export const BOOKING_STATUS_GROUPS = [
  { key: "pickup", label: "Pickup (UK)", statuses: [0, 1, 2, 3] },
  { key: "delivery", label: "Delivery (GH)", statuses: [4, 9, 5, 6, 8, 7] },
  { key: "other", label: "", statuses: [-1] },
];

export const getBookingStatus = (status) => BOOKING_STATUS[status] || null;
